import type { RiskStatus } from '@/utils/completionDateCalculation';

// Hex values mirror tailwind.config.js token definitions — update both together
export const STATUS_BORDER_COLORS: Record<RiskStatus, string> = {
  on_track: '#10b981', // success-500
  at_risk:  '#f59e0b', // warning-500
  overdue:  '#dc2626', // danger-600
  unknown:  '#9ca3af', // gray-400
};
